const QuestionOption = ({
  id,
  checked,
  onChange,
  label,
}: {
  id: string;
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
}) => {
  return (
    <div className="flex items-center p-1 my-2 mr-4">
      <input type="checkbox" id={id} checked={checked} onChange={onChange} />
      <label className="ml-1 cursor-pointer select-none" htmlFor={id}>
        {label}
      </label>
    </div>
  );
};

export default QuestionOption;
